<svelte:options tag={null} />

<script lang="ts">
  import type { CardTitleTag, CardSubtitleTag, CardRatio } from './card.types';

  export let title: string;
  export let imgsrc: string;
  export let outlined = false;
  export let titletag: CardTitleTag = 'h1';
  export let imgalt: string;
  export let subtitle: string;
  export let subtitletag: CardSubtitleTag = 'h2';
  export let imageratio: CardRatio = '4x3';
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
</script>

<div
  class="mc-card{outlined ? ' mc-card--bordered' : ''} {userClass}"
  {...attributes}
>
  <figure
    class="mc-card__visual {imageratio ? `mc-card__visual--${imageratio}` : ''}"
  >
    <img src={imgsrc} alt={imgalt} class="mc-card__img" />
  </figure>
  <article class="mc-card__content">
    {@html `<${titletag} class="mc-card__title">${title}</${titletag}>`}

    {#if subtitle}
      {@html `<${subtitletag} class="mc-card__subtitle">${subtitle}</${subtitletag}>`}
    {/if}

    <div class="mc-card__body">
      <slot />
    </div>

    {#if $$slots.footer}
      <footer class="mc-card__footer">
        <slot name="footer" />
      </footer>
    {/if}
  </article>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.button';
  @import '@mozaic-ds/styles/components/c.links';
  @import '@mozaic-ds/styles/components/c.card';
</style>
